export * from './BannerWideFeature';
